import { lazy, ReactElement } from 'react';
import { Route } from 'react-router';

import { useFeaturesInfo } from '#/hooks';

const PromoMms = lazy(
  () => import(/* webpackChunkName: "Mms" */ '#/pages/Promos/Mms/Mms')
);

/**
 * Hook that dynamically returns a set of promotional routes. It's done as a hook to allow lazy loading and to overcome React Router limitiations for nesting routes (because they are not really nested from React Router perspective, but we want them to behave like they are. This way App component is not garbaged with this logic).
 */
export function usePromoRoutes(): PromoRoutes {
  const { getPromoFeature } = useFeaturesInfo();

  const mmsConfig = getPromoFeature('NonSubscribedRedeem');

  return [
    mmsConfig?.enabled && (
      <Route
        element={<PromoMms />}
        key={mmsConfig?.key}
        path={mmsConfig?.properties.route}
      />
    ),
  ].filter(Boolean);
}

type PromoRoutes = ReactElement[];
